import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"
import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-10 w-full min-w-0 rounded-sm border border-input bg-bg px-3 py-2 text-base text-text transition-[border-color] duration-(--motion-hover-duration) pointer-coarse:h-11 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-ink-faint disabled:opacity-50 aria-invalid:border-text",
        className
      )}
      {...props}
    />
  )
}

export { Input }
